/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Year_BuiltInputs */

const cs_filter_year_built = /** @type {(inputs: Filter_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rok výstavby`)
};

const en_filter_year_built = /** @type {(inputs: Filter_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year built`)
};

/**
* | output |
* | --- |
* | "Year built" |
*
* @param {Filter_Year_BuiltInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_year_built = /** @type {((inputs?: Filter_Year_BuiltInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Year_BuiltInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_year_built(inputs)
	return cs_filter_year_built(inputs)
});